"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChallengeFaqDetailsToJSON = exports.ChallengeFaqDetailsFromJSONTyped = exports.ChallengeFaqDetailsFromJSON = void 0;
function ChallengeFaqDetailsFromJSON(json) {
    return ChallengeFaqDetailsFromJSONTyped(json, false);
}
exports.ChallengeFaqDetailsFromJSON = ChallengeFaqDetailsFromJSON;
function ChallengeFaqDetailsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'question': json['question'],
        'answer': json['answer'],
    };
}
exports.ChallengeFaqDetailsFromJSONTyped = ChallengeFaqDetailsFromJSONTyped;
function ChallengeFaqDetailsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'question': value.question,
        'answer': value.answer,
    };
}
exports.ChallengeFaqDetailsToJSON = ChallengeFaqDetailsToJSON;
